import { Action } from '../../../ngrx/actions/unsafe-action';

export const SET_PLANS = '[BILLING_PLAN] SET ALL PLANS ';

export class SetPlans implements Action {
  readonly type = SET_PLANS;

  constructor(public payload: any) {}
}
